/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

/**
 * Coerces an unknown catch/reject value to an `Error`. A thrown value may be
 * anything (a string, a rejected non-Error), so downstream handlers that want
 * a real `Error` (stack, `.message`) normalize through this first.
 */
export function asError(err: unknown): Error {
    return err instanceof Error ? err : new Error(String(err))
}

/**
 * Extracts a log-safe message from an unknown catch/reject value. Avoids the
 * `[object Object]` a raw `String(err)` yields for an `Error`.
 */
export function errorMessage(err: unknown): string {
    return err instanceof Error ? err.message : String(err)
}
